import { BarChart } from 'modules/salaries/types/BarChart';
import { LineChart } from 'modules/salaries/types/LineChart';
import { range } from 'utils/functional/array/range';

export function buildXTicks(
  barChart: BarChart | null,
  lineChart: LineChart | null,
): (number | string)[] {
  let xRangeMin = 0;
  let xRangeMax = 0;
  let xTicks = [];

  if (barChart && lineChart) {
    xRangeMin = Math.min(barChart.xRangeMin, lineChart.xRangeMin);
    xRangeMax = Math.max(barChart.xRangeMax, lineChart.xRangeMax);
  } else if (barChart) {
    xRangeMin = barChart.xRangeMin;
    xRangeMax = barChart.xRangeMax;
  } else if (lineChart) {
    xRangeMin = lineChart.xRangeMin;
    xRangeMax = lineChart.xRangeMax;
  }

  const numberOfTicks = 6;
  const tickInterval = (xRangeMax - xRangeMin) / (numberOfTicks - 1);

  const xRange = range(xRangeMin, xRangeMax + 1, tickInterval).map(
    (salary: number) =>
      salary.toLocaleString(CURRENT_LOCALE, {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
      }),
  );
  if (xRange.length > 6) {
    xTicks = [xRange[0]];
    const middleRange = xRange.slice(1, -1);
    const interval = middleRange.length / 4;

    for (let i = 0; i < 4; i++) {
      const evenIndex = Math.floor(i * interval + interval / 2);
      xTicks.push(middleRange[evenIndex]);
    }

    xTicks.push(xRange[xRange.length - 1]);
  } else {
    xTicks = xRange;
  }

  return xTicks;
}
